import { useTheme } from '@chakra-ui/react'
import '../../App.css'
import CarouselForComponents from '../../components/carouselCustom/carouselCustom';
import CarouselLittle from '../../components/carouselLittle/carouselLittle'
import SearcherCustom from '../../components/searcherCustom/searcherCustom';
import SlideCarouselLittle from '../../components/carouselSlides/trends/slideCarouselLittle';
import { SlideCareer } from '../../components/carouselSlides/main/career';
import SlideGeneralInfo from '../../components/carouselSlides/main/info';
import SlideCourses from '../../components/carouselSlides/main/courses';
import Characteristics from '../../components/characteristics/characteristics';
import Certificates from '../../components/certificates/certificates';
import TrustedBussiness from '../../components/trustedBussiness/trustedBussiness'
import ImageAndParagraph from '../../components/imageAndParagraph/imageAndParagraph';
import trayecto24 from '../../innerAsstes/Seccion trayecto/Recurso 24trayecto.png';
import Qualifications from '../../components/qualifications/qualifications';
import HomeBadges from '../../components/homeBadges/homeBadges';
import { useAppContext } from '../../App';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { getCategories } from '../../utils/dataFetch';
import { formatTextForCard } from '../../utils/functions';
import CustomLoader from '../../components/loader/customLoader';

export default function HomeScreen() {
  const getImgResource = (categoryName) => {
  try {
    return require(`../../innerAsstes/categories/${categoryName}.png`);
  } catch (error) {
    return require(`../../innerAsstes/categories/Programación y Tecnologías de la Información.png`);
  }
};
  const navigate = useNavigate();
  const theme = useTheme();
  const {isMobile, coursesInfo, setSelectedCategory, categoryItems, setCategories} = useAppContext();
  const style = styles(theme, isMobile);
  const whyUsDescription = `
    Nuestros cursos están certiﬁcados por universidades nacionales que
    garantizan los contenidos. A diferencia de otras plataformas, en cada
    curso encontrarás un docente para acompañarte durante toda la
    cursada. Además un tutor del Campus Virtual se comunica
    directamente en menos de 48hs de haber comprado el curso, para
    darte instrucciones de como comenzar.`;
  
  let newTrendCourses = coursesInfo?.filter(course => course.Destacado);
  let topCourses = coursesInfo?.filter(course => course.TopCurso);
  
  if(newTrendCourses?.length === 0) {
    newTrendCourses = coursesInfo?.slice(1, 5) || [];
  }
  if(topCourses?.length === 0) {
    topCourses = coursesInfo?.slice(1, 5) || [];
  }

  const getCourseType = (qty) => {
    return qty === 0? 'Cursos' : qty === 2? 'Trayecto Profesional' : 'Secretariados' 
  }

  useEffect(()=>{
    !categoryItems && getCategories().then(res =>{ 
      setCategories(res);
    });
  },[]);
  return (
    <div style={style.container}>
      <CarouselForComponents customStyles={style.mainCarouselStyles}>
        <SlideGeneralInfo />
        <SlideCareer />
        <SlideCourses />
      </CarouselForComponents>
      <SearcherCustom from={'home'} customStyles={{
        container:{
          padding: '2vh',
          paddingLeft: '5vw',
          paddingRight: '5vw',
          marginLeft: '5vw',
          marginRight: '5vw',
        }
      }}/>
      <HomeBadges/>
      <CarouselLittle titleFirst={"NUEVAS"} titleSecond={"TENDENCIAS"} customStyles={style.carousel} buttonRedirectTo={`/categorias-general/Cursos`}>
        {!newTrendCourses?
          <CustomLoader loaderText='CARGANDO LOS CURSOS...' customStyles={style.loader}/>:
          newTrendCourses.map((course,index) =>(
          <SlideCarouselLittle
  key={`slide-tendecia-${index}`}
  cardTitle={formatTextForCard('title', course.NombreCurso)}
  cardDescription={formatTextForCard('description', course.Descripcion)}
  buttonRedirectTo={`/formulario-inscripcion/${getCourseType(course.hijosqty)}/${course.category_name}/${course.IdCurso}`}
  additionalActionsForButton={() => setSelectedCategory(categoryItems.find(category => course.IdCategoria === category.IdCategoria))}
  imgSrc={getImgResource(course.category_name)}
  customStyles={{
    container: {
      minHeight: '310px',
      maxHeight: '340px',
      height: '340px',
    },
     img: {
      width: "90px",      // El ancho que prefieras solo para la home
      height: "90px",     // El alto que prefieras solo para la home
      objectFit: "contain",
      display: "block",
      margin: "auto",
      background: "white"
    }
    }}
/>
          ))
        }
      </CarouselLittle>
      <CarouselLittle titleFirst={"CURSOS"} titleSecond={"MÁS BUSCADOS"} customStyles={style.carousel2} buttonRedirectTo={`/categorias-general/Cursos`}>
        {!topCourses?
          <CustomLoader loaderText='CARGANDO LOS CURSOS...' customStyles={style.loader}/>:
          topCourses.map((course, index) =>(
            <SlideCarouselLittle
              key={`slide-mostWanted-${index}`}
              cardTitle={formatTextForCard('title',course.NombreCurso)}
              cardDescription={formatTextForCard('description',course.Descripcion)}
              buttonRedirectTo={`/formulario-inscripcion/${getCourseType(course.hijosqty)}/${course.category_name}/${course.IdCurso}`}
              additionalActionsForButton={ () => setSelectedCategory(categoryItems.find(category => course.IdCategoria === category.IdCategoria)) }
              imgSrc={getImgResource(course.category_name)}
              customStyles={{
              container: {
              minHeight: '310px',
              maxHeight: '340px',
              height: '340px',
            },
             img: {
              width: "90px",      // El ancho que prefieras solo para la home
              height: "90px",     // El alto que prefieras solo para la home
              objectFit: "contain",
              display: "block",
              margin: "auto",
              background: "white"
            }
          
  }}// imgSrc={assets5gestar}
            />
          ))
        }
      </CarouselLittle>
      <ImageAndParagraph
        imgSrc={trayecto24}
        titleFirst={'¿POR QUÉ HACER'}
        titleSecond={'NUESTROS CURSOS?'}
        description={whyUsDescription}
        buttonText='Saber más'
        buttonRedirectTo={'/sobre-nosotros'}
        customStyles={style.imgCustomStyles}
      />
      <Certificates />
      <Characteristics />
      <TrustedBussiness />
      <Qualifications />
    </div>
  );
}

const styles = (theme, isMobile) => ({
  container:{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingBottom: 20,
    backgroundColor: theme.background.primary
  },
  mainCarouselStyles:{
    paddingLeft: '5vw',
    paddingRight: '5vw'
  },
  carousel:{
    titleFirst: {
      fontSize: isMobile? '2.5rem':'3rem',
      lineHeight: isMobile? 1.2 : 'none',
      color: theme.color.text.tertiary
    },
    titleSecond: {
      fontSize: isMobile? '2rem':'2.5rem',
      lineHeight: isMobile? 1.2 : 'none',
      color: theme.color.text.primary
    }
  },
  carousel2:{
    container:{
      backgroundColor: theme.background.primary
    },
    titleFirst: {
      fontSize: isMobile? '2.5rem':'3rem',
      lineHeight: isMobile? 1.2 : 'none',
      color: theme.color.text.secondary
    },
    titleSecond: {
      fontSize: isMobile? '1.5rem':'2rem',
      lineHeight: isMobile? 1.2 : 'none',
      color: theme.color.text.primary
    }
  },
  imgCustomStyles:{
    container: {
      paddingTop: '3vh',
      paddingBottom: '3vh',
      marginLeft: '4vw',
      marginRight: '4vw',
      borderTop: '1px white dashed'
    },
    title1:{
      fontSize: isMobile? '1.6rem':'3rem',
      color: theme.color.text.secondary
    },
    title2:{
      fontSize: isMobile? '1.6rem':'3rem',
    },
    buttonStyles:{
      text:{
        fontSize: '1.2rem',
        width: 'auto',
      },
    },
    description: {
      textAlign: 'justify'
    }
  
  },
  loader:{
    container: {
      width: isMobile? '80vw':'30vw',
    },
    text:{
      fontSize: isMobile? '1rem':'1.5rem',
    },
  }
})
